import { createReducer, createAction } from 'redux-act'
import { select, apply, put, takeEvery, all } from 'redux-saga/effects'
import { get } from 'lodash'

import { selector as configSelector } from '~/config'

import { Entity, handleError } from '~/utils/entity-utils'

import API from '~/api'

const entityName = 'fileUpload';
const entity = new Entity(entityName, API, configSelector);

// ACTIONS
export const actions = {
  ...entity.actions,
  uploadFile: {
    request: createAction('upload file request', (file) => ({file})),
    failure: createAction('upload file failed', (message) => ({message})),
    success: createAction('upload file succeeded', (data) => ({data}))
  },
};

// WORKERS
export const workers = {
  ...entity.workers,
  * uploadFile (action) {
    const { file, progressHandler=()=>{} } = get(action, 'payload', {});

    try {
      const config = yield select(configSelector);
      const api = new API(config);
      let data = new FormData();
      data.append('file', file);
      const response = yield apply(api, api.uploadFile, [data, progressHandler]);

      //console.log(response.data);
      yield put(actions.uploadFile.success(response.data));
      return response.data;
    } catch (e) {
      handleError(e, actions.uploadFile);
      throw e;
    }
  }
};

// SAGA
export function * saga() {
  yield all([
    ...entity.saga,
    takeEvery(actions.uploadFile.request().type, workers.uploadFile)
  ]);
}

export const reducer = createReducer({
  ...entity.reducer,
  [actions.uploadFile.success]: (state, payload) => Object.assign({}, state, {[payload['data']['url']]: payload['data']}),
}, {});

export default {
  actions,
  workers,
  saga,
  reducer
}